module.exports = __webpack_public_path__ + "img/soccerboard21.592b8ebd.jpg";